import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Convert markdown bold/italic to HTML.
 * **text** → <strong>text</strong>
 * *text*  → <em>text</em>
 * Returns sanitized HTML string (only strong/em tags allowed).
 */
export function renderMarkdown(text) {
  if (!text || typeof text !== 'string') return '';
  let html = text
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
    .replace(/(?<!\*)\*([^*]+?)\*(?!\*)/g, '<em>$1</em>');
  return html;
}

/**
 * Normalize a patient type string for comparison.
 * Removes accents, converts to lowercase, strips non-alphanumeric chars.
 */
export function normalizeType(str) {
  if (!str) return '';
  return str.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]/g, '');
}

/**
 * Check if a patient belongs to a specific program type.
 * Handles different formats: 'introducao_alimentar', 'Introdução alimentar', etc.
 */
export function patientHasType(patient, typeKeyword) {
  const norm = normalizeType(typeKeyword);
  const pt = normalizeType(patient?.patient_type);
  if (pt && pt.includes(norm)) return true;
  const pts = patient?.patient_types || [];
  return pts.some(t => normalizeType(t).includes(norm));
}

export const isBabyPatient = (p) => {
  // A API calcula a deteção única (categorias, ementa publicada, idade < 2 anos)
  if (typeof p?.is_baby_patient === 'boolean') return p.is_baby_patient;
  if (patientHasType(p, 'introducao')) return true;
  // Check by age: birth_date within last 2 years = baby
  const bd = p?.birth_date;
  if (bd) {
    try {
      const m = /^(\d{2})[/-](\d{2})[/-](\d{4})/.exec(bd);
      const birthDate = m ? new Date(`${m[3]}-${m[2]}-${m[1]}`) : new Date(bd);
      const ageMs = Date.now() - birthDate.getTime();
      const ageYears = ageMs / (365.25 * 24 * 60 * 60 * 1000);
      if (ageYears >= 0 && ageYears < 2) return true;
    } catch {}
  }
  return false;
};
export const isGravidaPatient = (p) => patientHasType(p, 'gravida');
export const isPosPartoPatient = (p) => patientHasType(p, 'posparto') || patientHasType(p, 'pos_parto');
export const isPreConcPatient = (p) => patientHasType(p, 'preconce') || patientHasType(p, 'pre_conc');
